import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "display", "textarea", "preview"]

  connect() {
    this.stats = {}
    const raw = this.element.dataset.dashboardBlurbStatsValue
    if (raw) {
      try {
        this.stats = JSON.parse(raw)
      } catch {
        this.stats = {}
      }
    }
    if (this.hasTextareaTarget) {
      this.updatePreview()
    }
  }

  open() {
    if (!this.hasModalTarget) return
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    if (this.hasTextareaTarget) {
      this.textareaTarget.focus()
      this.updatePreview()
    }
  }

  close() {
    if (!this.hasModalTarget) return
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  toggle() {
    if (!this.hasModalTarget) return
    if (this.modalTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  applyPreset(event) {
    if (!this.hasTextareaTarget) return
    this.textareaTarget.value = event.currentTarget.dataset.template
    this.updatePreview()
    this.textareaTarget.focus()
  }

  insertShortcode(event) {
    if (!this.hasTextareaTarget) return
    const shortcode = event.currentTarget.dataset.shortcode
    const textarea = this.textareaTarget
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    textarea.value = `${textarea.value.slice(0, start)}${shortcode}${textarea.value.slice(end)}`
    textarea.selectionStart = textarea.selectionEnd = start + shortcode.length
    textarea.focus()
    this.updatePreview()
  }

  updatePreview() {
    if (!this.hasPreviewTarget || !this.hasTextareaTarget) return
    const escaped = this.escapeHtml(this.textareaTarget.value || "")
    let html = escaped
    Object.entries(this.stats || {}).forEach(([key, value]) => {
      const token = `[${key}]`
      const pill = `<span class="bg-beige-300 text-beige-900 px-2 py-0.5 rounded font-medium">${value}</span>`
      html = html.split(token).join(pill)
    })
    this.previewTarget.innerHTML = html.replace(/\n/g, "<br>")
  }

  escapeHtml(value) {
    return value
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }
}
